<template>
  <v-select
    :items="values"
    label="Pagamento Online"
    item-text="text"
    item-value="value"
    v-model="valueSelecionado"
    chips
    multiple
  />
</template>

<script>
export default {
  name: 'FiltroPagamentoOnline',
  data() {
    return {
      values: [
        {
          text: 'Não',
          value: 0
        },
        {
          text: 'Sim',
          value: 1
        },
        {
          text: 'Trazer somente pedidos pagos pelo app',
          value: 2
        },
        {
          text: 'Não interessados',
          value: 3
        }
      ],
      valueSelecionado: null
    }
  },
  watch: {
    valueSelecionado() {
      this.$emit('filtrar-pagamento-online', {
        pagamento_online: this.valueSelecionado
      })
    }
  }
}
</script>
